// * Base
import { InjectionToken, Signal } from '@angular/core';

export interface SntBaseSettings {
  display_decimal_places: number;
  is_24h_format_enabled: boolean;
  currency: string;
  lang: string;
  [key: string]: any;
}

export const SNT_ORG_CONFIG = new InjectionToken<Signal<SntBaseSettings>>('org-settings-token');
